import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import DatePicker from "../../../Components/Common/FieldTypes/DatePicker/DatePicker";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import SelectDropdown from "../../../Components/Common/FieldTypes/SelectDropdown/SelectDropdown";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";

function MedicalDetails() {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState<{
    fullName: { value: string; warning: boolean };
    mobile: { value: string; warning: boolean };
    address: { value: string; warning: boolean };
  }>({
    fullName: { value: "", warning: false },
    mobile: { value: "", warning: false },
    address: { value: "", warning: false },
  });

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  const [alignment, setAlignment] = React.useState<string | null>("left");

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setAlignment(newAlignment);
  };

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Medical Details" />
              </Grid>
              <Grid xs={12}>
                <Box display="flex" gap="12px">
                  <h5
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      marginBottom: "12px",
                      display: "flex",
                      gap: "8px",
                      width: "100%",
                    }}
                  >
                    <GppMaybeIcon />
                    Has anyone been diagnosed / hospitalized / or under any
                    treatment for any illness / injury?
                  </h5>
                  <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    aria-label="text alignment"
                    className="toggleButton"
                  >
                    <ToggleButton value="left" aria-label="left aligned">
                      Yes
                    </ToggleButton>
                    <ToggleButton value="center" aria-label="centered">
                      No
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                <p style={{ fontSize: "14px" }}>
                  e.g. Diabetes, hypertension, heart disease, Zika, flu etc.
                </p>
              </Grid>
            </Grid>

            {/* If Yes */}
            <Grid container spacing={3}>
              <Grid xs={12}>
                <h5>Please fill Rahul's doctor details:</h5>
              </Grid>
              <Grid xs={8}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Name of the medical doctor or specialist"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={5}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Doctor's Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={7}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Doctor's Address"}
                  value={formFields.address.value}
                  attrName={["address", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.address.warning}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn text-center">
                <CustomButton
                  onClickFunction={() => {
                    navigate(PATH.TRAVELLER_INFORMATION);
                  }}
                  text_name="Continue"
                  class_name="blueXlBtn"
                />
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default MedicalDetails;
